import { API } from "@/App";
import { resolveMediaUrl } from "@/lib/mediaUrl";

const isVideo = (s = "") => /\.(mp4|mov|webm)(\?|$)/i.test(s);

/** Photos / videos the customer attached in Yorm Ai — shown to drivers before and after accepting. */
export default function RequestMedia({ media, testId = "request-media", title = "Customer photos & videos" }) {
  if (!Array.isArray(media) || !media.length) return null;
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-2.5" data-testid={testId}>
      <p className="mb-1.5 text-[11px] font-semibold text-gray-600">{title}</p>
      <div className="flex flex-wrap gap-1.5">
        {media.map((u, i) => {
          const src = resolveMediaUrl(u, API);
          return isVideo(u) ? (
            <video key={i} src={src} controls playsInline preload="metadata" className="h-16 w-16 rounded-md bg-black object-cover" data-testid={`${testId}-video-${i}`} />
          ) : (
            <a key={i} href={src} target="_blank" rel="noopener noreferrer" className="block">
              <img src={src} alt={`Customer attachment ${i + 1}`} className="h-16 w-16 rounded-md object-cover border border-gray-200 hover:opacity-90 transition-opacity" data-testid={`${testId}-photo-${i}`} />
            </a>
          );
        })}
      </div>
    </div>
  );
}
